import { combineReducers } from "redux"
import cartReducer from "./cartReducer"
import globalReducer from "./globalReducer"
import filterReducer from "./filterReducer"
import productReducer from "./productReducer"
import getStoneReducer from "./getstoneReducer"

const rootReducer = combineReducers({
  cartdata: cartReducer,
  globaldata: globalReducer,
  productdata: productReducer,
  getStonedata: getStoneReducer,
  filterReducer: filterReducer,
})
export default rootReducer